import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { VcaAlert } from './vca-alert';

@Injectable()
export class VcaAlertsService {
    public alerts;
    private _alerts = new Subject<VcaAlert>();

    constructor() {
        this.alerts = this._alerts.asObservable();
    }

    public add(message: any, type: string, location?: string, timeout?: number) {
        this._alerts.next(new VcaAlert(message, type, location, timeout));
    }

    public info(message: any, location?: string) {
        this._alerts.next(new VcaAlert(message, 'info', location));
    }

    public warning(message: any, location?: string) {
        this._alerts.next(new VcaAlert(message, 'warning', location));
    }

    public success(message: any, location?: string) {
        this._alerts.next(new VcaAlert(message, 'success', location));
    }

    public danger(message: any, location?: string) {
        this._alerts.next(new VcaAlert(message, 'danger', location));
    }
}



// WEBPACK FOOTER //
// ./src/common/vca-alerts/vca-alerts.service.ts